module.exports = __webpack_public_path__ + "img/freja-nyc_thumbnail.063f605b.jpg";